import React from "react";

import { Container, Content, ActionsContent, ConfirmButton, ModalText } from "./styles";

import { IoWarningOutline } from "react-icons/io5";

import useUser from "@hooks/useUser";

const ModalNoMap = () => {
  const { logoutUser } = useUser();

  return (
    <Container>
      <Content>
        <IoWarningOutline size={80} />
        <ModalText>
          Você não possui acesso ao mapa. Entre em contato com o seu gerente ou administrador para
          configurar sua conta.
        </ModalText>
      </Content>
      <ActionsContent>
        <ConfirmButton onClick={() => logoutUser()}>
          <p>Sair</p>
        </ConfirmButton>
      </ActionsContent>
    </Container>
  );
};

export default ModalNoMap;
